import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const seizingReleaseSlice = createSlice({
  name: "seizingRelease",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    vehicleslist: [],
    model: false,
    drawer: false,
    error_msg: null,
    previewFile: {},

    listCount: 0,
    rowdata: {
      id: 0,
    },
    vehiclesParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
    },
    filterStatus: false,
  },
  reducers: {
    clearVehicleData: (state, action) => {
      return {
        ...state,
        rowdata: {
          id: 0,
        },
        vehicleslist: [],
      }
    },
    getVehicles: (state, action) => {
      if (state.vehiclesParams?.page == 1) {
        return {
          ...state,
          loading: true,
          vehicleslist: [],
        };
      } else {
        return {
          ...state,
          loading: true,
        };
      }
    },
    vehiclesListSuccessful: (state, action) => {
      console.log("action payuload..", action.payload)
      var noofpages = Math.ceil(
        action.payload.count / state.vehiclesParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.count,
        vehicleslist: action.payload.results,
        loading: false,
        vehiclesParams: {
          ...state.vehiclesParams,
          no_of_pages: noofpages,
        },
      };
    },
    SetVehiclesParams: (state, action) => {
      return {
        ...state,
        vehiclesParams: action.payload,
      };
    },

    vehiclesAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    vehiclesAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    vehiclesDelete: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    addImageUpload: (state, action) => {
      return {
        ...state,
        // imageLooading: true,
        // vehicleImg: [...state.vehicleImg, action.payload],
        // estimationData: {...state.estimationData,   ...action.payload}
        rowdata: {
          ...state.rowdata,
          [action.payload.imageType]: action.payload.file,
        }
      };
    },
    setPreviewImg: (state, action) => {
      return {
        ...state,
        // imageLooading: false,
        rowdata: {
          ...state.rowdata,
          previewFile: action.payload,
        }
      }
    },
    InputChangeValue: (state, action) => {
      switch (action.payload.key) {
        case "vehicleType":
          if (action.payload.value == "old") {
            return {
              ...state,
              rowdata: {
                ...state.rowdata,
                vehicleno: null,
                [action.payload.key]: action.payload.value,
              },
            };
          } else {
            return {
              ...state,
              rowdata: {
                ...state.rowdata,
                [action.payload.key]: action.payload.value,
              },
            };
          }
        case "brand_id":
          return {
            ...state,
            rowdata: {
              ...state.rowdata,
              [action.payload.key]: action.payload.value,
              brandfamily_id: null,
              model_id: null,
              version_id: null,
            },
          };

        case "brandfamily_id":
          return {
            ...state,
            rowdata: {
              ...state.rowdata,
              [action.payload.key]: action.payload.value,
              model_id: null,
              version_id: null,
            },
          };

        case "model_id":
          return {
            ...state,
            rowdata: {
              ...state.rowdata,
              [action.payload.key]: action.payload.value,
              version_id: null,
            },
          };
        default:
          return {
            ...state,
            rowdata: {
              ...state.rowdata,
              [action.payload.key]: action.payload.value,
            },
          };
      }
    },
    isModelVisible: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },

    isDrawerVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          drawer: action.payload,
          // enquiryData: {},
        };
      } else {
        return {
          ...state,
          drawer: action.payload,
        };
      }
    },
    FilterInputChangeValue: (state, action) => {
      switch (action.payload.key) {
        case "version__brand":
          return {
            ...state,
            vehiclesParams: {
              ...state.vehiclesParams,
              [action.payload.key]: action.payload.value,
              version__brandfamily: null,
              version__model: null,
            },
          };

        case "version__brandfamily":
          return {
            ...state,
            vehiclesParams: {
              ...state.vehiclesParams,
              [action.payload.key]: action.payload.value,
              version__model: null,
            },
          };
        default:
          return {
            ...state,
            vehiclesParams: {
              ...state.vehiclesParams,
              [action.payload.key]: action.payload.value,
            },
          };
      }
    },
    vehicleNumberValidate: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    engineNumberValidate: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    chassisNumberValidate: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    getvehicleByID: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    getvehicleImagesByID: (state) => {
      return {
        ...state,
        loading: true,
      };
    },


    vehicleByIDSuccessful: (state, action) => {
      const r = action.payload; // backend response

      return {
        ...state,
        loading: false,
        model: true,
        rowdata: {
          ...r,
          id: r.id,

          // VEHICLE
          vehicle_id: r.vehicle?.id,
          vehicle_no: r.vehicle?.vehicleno,

          // DROP-DOWN DATA (brand > family > model > version)
          brand: r.vehicle?.version?.brand || null,
          brandfamily: r.vehicle?.version?.brandfamily || null,
          model: r.vehicle?.version?.model || null,
          version: r.vehicle?.version || null,

          // RELEASE INFO
          year: r.release_date,
          reason_id: typeof r.release_purpose === 'object' ? r.release_purpose?.id : r.release_purpose,
          seizing_officer_for_release_id: r.seizing_officer_for_release?.id,
          seizing_officer_for_release_name: r.seizing_officer_for_release?.fullname,
          seizing_officer_id: action.payload?.seizing_officer?.id,

          // PHONE
          mobile_no: r.phone,

          // LOAN NO
          veh_loan_account_no: r.veh_loan_account_no,

          // LOCATION
          location_type: r.location_type,
          own_place: r.own_place,


          image1: r.godown_vehicle?.vehiclefront_image
            ? [{
              uid: "-1",
              name: "vehiclefront_image.jpeg",
              status: "done",
              url: r.godown_vehicle.vehiclefront_image
            }]
            : [],
          image2: r.godown_vehicle?.vehicleback_image
            ? [{
              uid: "-2",
              name: "vehicleback_image.jpeg",
              status: "done",
              url: r.godown_vehicle.vehicleback_image
            }]
            : [],
          image3: r.godown_vehicle?.vehicleleft_image
            ? [{
              uid: "-3",
              name: "vehicleleft_image.jpeg",
              status: "done",
              url: r.godown_vehicle.vehicleleft_image
            }]
            : [],
          image4: r.godown_vehicle?.vehicleright_image
            ? [{
              uid: "-4",
              name: "vehicleright_image.jpeg",
              status: "done",
              url: r.godown_vehicle.vehicleright_image
            }]
            : [],
          image5: r.godown_vehicle?.otherimage
            ? [{
              uid: "-5",
              name: "otherimage.jpeg",
              status: "done",
              url: r.godown_vehicle.otherimage
            }]
            : [],

          video1: r.godown_vehicle?.video
            ? [{
              uid: "-6",
              name: "video.jpeg",
              status: "done",
              url: r.godown_vehicle.video
            }]
            : [],

          // video1: r.godown_vehicle?.video
          //   ? { preview: r.godown_vehicle.video }
          //   : null,
        },
      };
    },

    vehicleImagesByIDSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        model: true,
        rowdata: {
          ...action.payload.response2,
          image1: {
            preview: action.payload.response?.vehiclefront_image
          },
          image2: {
            preview: action.payload.response?.vehicleback_image
          },
          image3: {
            preview: action.payload.response?.vehicleleft_image
          },
          image4: {
            preview: action.payload.response?.vehicleright_image
          },
          image5: {
            preview: action.payload.response?.otherimage
          },
          video1: {
            preview: action.payload.response?.video
          },
          vehicle_id: action.payload.response2?.vehicle?.id,
          year: action.payload.response2?.seizure_date,
          seizing_officer_id: action.payload.response2?.seizing_officer?.id,
          // seizing_officer:action.payloadseizing_officer.id,
          veh_loan_account_no: action.payload.response2?.veh_loan_account_no,
        },
      };
    },
    // SetVehiclesFilterParams: (state, action) => {
    //   return {
    //     ...state,
    //     vehiclesFilterParams: action.payload,
    //   };
    // },
    fsyncStatusUpdate: (state, action) => {
      return {
        ...state,
        loading: true,
      }
    },
    checkFilterStatus: (state, action) => {
      return {
        ...state,
        filterStatus: action.payload,
      };
    },
    apiError: (state, action) => {
      return {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
    },
  },
});
export const {
  getVehicles,
  vehiclesListSuccessful,
  vehiclesAdd,
  vehiclesAddSuccessful,
  vehiclesDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetVehiclesParams,
  isDrawerVisible,
  FilterInputChangeValue,
  vehicleNumberValidate,
  engineNumberValidate,
  chassisNumberValidate,
  getvehicleByID,
  getvehicleImagesByID,
  vehicleByIDSuccessful,
  vehicleImagesByIDSuccessful,
  fsyncStatusUpdate,
  checkFilterStatus,
  clearVehicleData,
  addImageUpload,
  setPreviewImg
} = seizingReleaseSlice.actions;

export default seizingReleaseSlice.reducer;
